import styled from "styled-components";

export const Container = styled.div`  
  padding: 6px;
  margin-left: -8px;
`;

export const DateArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  //width: 60px;
  //height: 52px;
  //border-radius: 4px;
  //margin-right: 12px;

  /* margin-top: 18px;
  margin-bottom: 8px;
  margin-left: 12px;
  margin-right: 12px; */
`;

export const Day = styled.div`
  margin-top: 2px;
  display: flex;
  bottom: 0px;
`;

export const Hour = styled.div`
  margin-top: -15px;  
  display: flex;
  top: 0px;
`;
 